module.exports = __webpack_public_path__ + "ef70660e974d91cf8e8e2ca663326bda.gif";